import axios from "axios";
import qs from "qs";
import { getToken } from "./service";
import Storage from "../utils/Storage";
import moment from "moment";
import _ from "underscore";
import Config from "../config";

export enum ExperiState {
    Idle = 0, //未开始
    InProgress = 1, //进行中
    Done = 2 //结束
}

export const ExperiStateMap = {
    [ExperiState.Idle]: "未开始",
    [ExperiState.InProgress]: "进行中",
    [ExperiState.Done]: "已结束"
};

export interface ExperiListItem {
    id: number; //活动ID
    weekTimeId: number; //周次节ID
    name: string; //活动名称
    osName: string; //操作系统
    useCount: string; //预约数量
    beginTime: string; //开始时间
    endTime: string; //结束时间
    resId: string; //项目ID
    delStatus: string; //删除状态0:未删除 1:已删除
    createTime: string; //创建时间
    updateTime: string; //修改时间
    createUser: string; //创建的教师ID
    updateUser: string; //修改的ID
    useStatus: string; //使用状态0:未开始 1:进行中 2:已结束
    projectName: string; //云桌面名称
    url: string; //实验地址
}

/**
 * 获取云桌面活动列表
 */

export function getCloudDeskTopList(weekTimeId: number) {
    const token = getToken();
    return axios
        .post<SuccessData<ExperiListItem[]>>(
            "/teacher/cloudDeskTop/getCloudDeskTopList",
            qs.stringify({ weekTimeId }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

interface ExperiForm {
    cloudGuid: string; //云桌面ID
    name: string; //标题
    useCount: string; //需要预约的人数
    resId: string; //项目ID(下拉列表里获取)
    beginTime: string; //开始时间
    endTime: string; //结束时间
    weekTimeId: string; //周次节ID
    osName: string; //操作系统
}

/**
 * 添加云桌面活动
 */

export function addCloudDeskTop(data: ExperiForm) {
    const token = getToken();
    return axios.post<SuccessData<ExperiForm>>(
        "/teacher/cloudDeskTop/addCloudDeskTop",
        qs.stringify(data),
        { headers: { token } }
    );
}

interface ProjectListItem {
    id: string;
    projectName: string;
    batchNo: string;
    courseNo: string;
    courseSeq: string;
    cloudGuid: string;
    courseId: string;
    createTime: string;
    updateTime: string;
    createUser: string;
    updateUser: string;
}
/**
 * 获取项目下拉列表
 */

export function getProjectList(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .post<SuccessData<ProjectListItem[]>>(
            "/teacher/cloudDeskTop/getProjectList",
            qs.stringify({ courseNo, courseSeq }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

export interface CloudDeskInfo {
    DesktopCount: number; //云桌面VM总数
    OsName: string; //云桌面操作系统名称
    SoftWare: string; //云桌面软件清单
    CloudGuid: string; //云ID
    CanUseCount: string; //能使用的数量
    Name_label: string; //云桌面名称
}

/**
 * 获取云桌面信息（选中后下拉后调用该接口）
 */
export function getCloudDeskInfo(cloudGuid: string) {
    const token = getToken();
    return axios.post<SuccessData<CloudDeskInfo>>(
        "/teacher/cloudDeskTop/getCloudDeskInfo",
        qs.stringify({ cloudGuid }),
        { headers: { token } }
    );
}

/**
 * 删除活动
 */

export function removeCloudDeskTop(cloudDeskTopId: number) {
    const token = getToken();
    return axios.post<SuccessData<ProjectListItem[]>>(
        "/teacher/cloudDeskTop/removeCloudDeskTop",
        qs.stringify({ cloudDeskTopId }),
        { headers: { token } }
    );
}

/**
 * 取消预约云桌面
 */

export function cancelCloudDesk(weekTimeId: number, cloudDeskTopId: string) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios.post<SuccessData<ProjectListItem[]>>(
        "/teacher/cloudDeskTop/cancelCloudDesk",
        qs.stringify({ weekTimeId, cloudDeskTopId }),
        { headers: { token, batchNo } }
    );
}

/**
 * 获取预约人数
 */

export function getCloudDeskPersonNum(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .post(
            "/teacher/cloudDeskTop/getCloudDeskPersonNum",
            qs.stringify({ courseNo, courseSeq }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

export function goToExperimentUrl(url: string) {
    window.open(url);
}

interface CourseInfo {
    courseNo: string; //课程编号
    courseSeq: string; //课程序号
    courseName: string; //课程名称
}

export interface TableItem {
    OrderGuid: string;
    courseInfo: CourseInfo; //课程信息
    BeginDay: string; //开始时间
    EndDay: string; //结束时间
    Used: string; //预约数量
    Total: string; //剩余数量
    CanUse: string; //可用数量
    courseNo: string; //课程编号
    courseSeq: string; //课程序号
    courseName: string; //课程名称
    key: number;
}

interface CloudInfoList {
    CloudTotal: number;
    OrderList: TableItem[];
}
/**
 * 查看资源列表
 */

export function getCloudInfoList(
    cloudGuid: string,
    beginTime: string,
    endTime: string
) {
    const token = getToken();
    return axios
        .post<SuccessData<CloudInfoList>>(
            "/teacher/cloudDeskTop/getCloudInfoList",
            qs.stringify({ cloudGuid, beginTime, endTime }),
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(data => {
            const onSelect: { [key: string]: any } = {};
            const dataList: TableItem[] = [];
            data.OrderList.map((item, index) => {
                const { courseNo } = item;
                if (!_.has(onSelect, courseNo)) onSelect[courseNo] = item;

                // dataList
                dataList.push({
                    ...item,
                    key: index,
                    courseInfo: {
                        courseNo: item.courseNo,
                        courseSeq: item.courseSeq,
                        courseName: item.courseName
                    },
                    BeginDay: moment(item.BeginDay).format("YYYY-MM-DD HH:mm"),
                    EndDay: moment(item.EndDay).format("YYYY-MM-DD HH:mm")
                });
            });

            //降序排列
            dataList.sort((a: any, b: any) => {
                return moment(b.BeginDay).diff(moment(a.BeginDay));
            });
            return { onSelect: _.values(onSelect), dataList };
        });
}

// 筛选项类型
interface TextObj {
    courseName: string;
    courseSeq: string;
    courseNo: string;
}

export interface FilterListItem {
    text: TextObj;
    value: string;
    isChecked: boolean;
}
